import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import StepFour from "./StepFour";
import StepFive from "./StepFive";
import EmploymentHistory from "./EmployementHistory";
import { OnboardingStepsEnums } from "../../../constants/onboarding";
import { OnboardingForms } from "../../../typings/onboarding";
import CurrentAddress from "./CurrentAddress";

export const renderSteps = ({
  currentStepIndex,
  setpreStepIndex,
  errors,
  formData,
  setFormData,
  steps,
  isEditClick,
  isEdit,
  docsArr,
  setDocsArr,
  leaseApplicationid,
  goToApplicationView,
  leaseApplicationTemplateSections,
  isPrint,
  tenantId
}: {
  currentStepIndex: number;
  setpreStepIndex: any;
  errors:any;
  //  errors: OnboardingFormErrorsType;
  formData: OnboardingForms;
  setFormData: React.Dispatch<React.SetStateAction<OnboardingForms>>;
  //steps: OnboardingStepsEnums[];
  steps: any;
  isEditClick: any;
  isEdit: boolean
  docsArr: any; setDocsArr:any;
  leaseApplicationid: Number
  goToApplicationView: any,
  leaseApplicationTemplateSections: any;
  isPrint: boolean
  tenantId:any

}) => {
  switch (steps[currentStepIndex]) {
    case OnboardingStepsEnums.CurrentAddress:
      return (
        <CurrentAddress
          formData={formData?.CurrentAddress}
          setFormData={setFormData}
          CurrentAddress={leaseApplicationTemplateSections?.CurrentAddress}
        />
      )
    case OnboardingStepsEnums.RentIncomeCheck:
      return (
        <StepTwo
          formData={formData?.RentIncomeCheck}
          setFormData={setFormData}
          errors={errors?.RentIncomeCheck}
          currentStepIndex={currentStepIndex}
          leaseApplicationid={leaseApplicationid}
          docsArr={docsArr}
          setDocsArr={setDocsArr}
          RentIncomeCheck={leaseApplicationTemplateSections?.RentIncomeCheck}
          tenantId={tenantId}
        />
      );
    case OnboardingStepsEnums.CreditCheck:
      return (
        <StepThree
          formData={formData?.CreditCheck}
          setFormData={setFormData}
          errors={errors?.CreditCheck}
          CreditCheck={leaseApplicationTemplateSections?.CreditCheck}
        />
      );
    case OnboardingStepsEnums.EmploymentHistory:
      return (
        <EmploymentHistory
          formData={formData?.EmploymentHistory}
          setFormData={setFormData}
          EmploymentHistory={leaseApplicationTemplateSections?.EmploymentHistory}
          requiredRange={leaseApplicationTemplateSections?.EmploymentHistory?.requiredRange}
        />
      );
    case OnboardingStepsEnums.References:
      return (
        <StepFour
          formData={formData?.References}
          setFormData={setFormData}
          References={leaseApplicationTemplateSections?.References}
          requiredRange={leaseApplicationTemplateSections?.References?.requiredRange}
        />
      );
    case OnboardingStepsEnums.Questionnaires:
      return (
        <StepFive
          formData={formData?.Questionnaires}
          setFormData={setFormData}
          Questionnaires={leaseApplicationTemplateSections?.Questionnaires?.questions}
        />
      );
  
   
    default:
      return null;
  }
};



